import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError, tap } from 'rxjs';
import { AuthService } from '../../services/auth.service';

const isInvalidTokenCode = (value: unknown): boolean => {
  if (value == null) return false;
  const n = Number(value as any);
  if (!Number.isNaN(n) && n === 202) return true;
  if (typeof value === 'string') {
    const s = (value as string).toLowerCase();
    return s.includes('invalid') || s.includes('result_invalid') || s.includes('invalid_token');
  }
  return false;
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(AuthService);

  return next(req).pipe(
    tap((event) => {
      // if we get a full HttpResponse
      if (event instanceof HttpResponse) {
        const body = event.body as Record<string, unknown> | null;
        if (
          event.status === 202 ||
          isInvalidTokenCode(body?.['codigo']) ||
          isInvalidTokenCode(body?.['codigo_respuesta'])
        ) {
          authService.handleInvalidSession();
        }
        return;
      }

      // some requests are configured with `observe: 'body'` and emit the body directly
      const bodyOnly = event as unknown as Record<string, unknown> | null;
      if (
        bodyOnly &&
        (isInvalidTokenCode(bodyOnly['codigo']) || isInvalidTokenCode(bodyOnly['codigo_respuesta']))
      ) {
        authService.handleInvalidSession();
      }
    }),
    catchError((error: HttpErrorResponse) => {
      const body = error.error as Record<string, unknown> | null;
      if (
        error.status === 202 ||
        isInvalidTokenCode(body?.['codigo']) ||
        isInvalidTokenCode(body?.['codigo_respuesta'])
      ) {
        authService.handleInvalidSession();
      }
      return throwError(() => error);
    })
  );
};
